/* eslint-disable react/prop-types */
import * as React from 'react';
import { CLAIM_STATUS_BACKGROUTD, CLAIM_STATUS_TEXT, PRODUCT_TYPE } from '@constants';
import { formatTime } from '@/utils';
import defaultImg from '@assets/default_img.svg';
import { PolicyPanel } from './components/PolicyPanel';
import { POLICY_ISSUE_TEXT, paymentMethods } from './constants';
import { ReimbursedItem } from './components/ReimbursedItem';
import { IssueItem } from './components/IssueItem';
import classes from './PolicyDetailClaim.module.css';
import useSettings from '../../hooks/useSettings';

const titleIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAgVBMVEUAAAD/54f/64v/6or/34D/6or/6oj/6or/6on/64r/6or/64n/64v/6Yn/74//54f/6or///+KYRavjDqZdTPx69vTt1/bwGXMrlf49fHx6+LazbbTxKj/7qDMupn44oOniFC9nUingzOZciSSaR3iyG2vjDuRayTi2MXbzra9nEhJpvBHAAAAEHRSTlMAIO/fEJ+QYN/Pz6CPMBBgeal72QAAATtJREFUOMuFU+magyAMRItHa3Ul4lnrfbT7/g+4VTAL+n12fikzSSaEkH9Qx7qZYWjePIeSIwz7QyI8Y0fTe7jDnWrhl/CAi5LER15T+CfxWg668XUW/YZhGyWoED42f+MAwBmbAfp0c7oW2PQRNFXOWFFy6LazpYgnv5/xi0m846c8tAkJxFfaxUxBHIkqJiWOEPTwUAUvGOr13JEVEuBMQwOiF4tcpcFSF1QQrcSViBFlc6ELct4KE0TaZQdI4qtAlmh5rtMFz0QJNFnpghJNWrLNRhdwbNMRgxz0i3pDLyz8kECYGCf9qjs5UEqIjcPCHA8clqWOuwNeFozlVQOROm5MkfYA82IPhhGnvSDAJ5lMn+bbKavlv0vPH61rnD971z9fHIwXPuw9b9P98loKa9pK+HH9LXX9/wB5lDcJgxqOzgAAAABJRU5ErkJggg==';
const ClaimIssueMap = {
  [PRODUCT_TYPE.Return]: ReimbursedItem,
  [PRODUCT_TYPE.Buyer]: IssueItem,
  [PRODUCT_TYPE.Assured]: ReimbursedItem,
};
const Dot = ({ width = 8, height = 8, color = '#645AFF' }) => {
  const style = {
    width,
    height,
    backgroundColor: color,
  };
  return <div className={classes.dot} style={style}></div>;
};

const ClaimStatus = ({ status }) => {
  if (!status) {
    return null;
  }
  return (
    <div className={classes.status} style={{ backgroundColor: CLAIM_STATUS_BACKGROUTD[status] }}>
      <span className={classes.statusText}>{CLAIM_STATUS_TEXT[status]}</span>
    </div>
  );
};

const PackageItem = ({
  orderName, packageItem, index,
}) => {
  if (!packageItem) {
    return null;
  }
  const {
    items, attachments = [], comment, reason,
  } = packageItem || {};

  return (
    <section>
      {index !== 0 ? <section className={classes.split_line} /> : null}
      <section className={classes.package_item}>
        <span className={classes.order_name_title}>Order</span>
        {orderName}
      </section>
      {items?.map((item, itemIndex) => {
        const files = attachments.map((file) => file.originalFileName);
        const {
          actualPrice,
          price,
          hasDiscount,
          imageUrl = defaultImg,
          itemTitle: title,
          sku,
          variantTitle,
          quantity,
        } = item || {};
        return (
          // eslint-disable-next-line react/no-array-index-key
          <section key={`${item.lineItemId}_${itemIndex}`}>
            {itemIndex === 0 ? null : <section className={classes.split_line} />}
            <section className={classes.merchandise}>
              <section className={classes.content}>
                <section className={classes.item_info}>
                  <img
                    src={imageUrl || defaultImg}
                    className={classes.item_img}
                    alt=""
                    onError={(e) => {
                      const img = e.currentTarget;
                      img.src = defaultImg;
                      img.οnerrοr = null;
                    }}
                  />
                  <section className={classes.info_block}>
                    {title ? <section className={classes.title}>{title}</section> : null}
                    {variantTitle
                      && <section className={classes.sub_title}>{variantTitle}</section>}
                    {sku ? <section className={classes.sub_title}>{`SKU: ${sku}`}</section> : null}
                  </section>
                </section>
                <section className={classes.price_block}>
                  {price ? <section className={classes.price}>{actualPrice}</section> : null}
                  {hasDiscount ? <section className={classes.actual_price}>{price}</section> : null}
                </section>
                {!!quantity && <section className={classes.claim_quantity}>{`x${quantity}`}</section>}
              </section>

            </section>
            {reason
              && (
                <section className={classes.remark}>
                  <section className={classes.remark_header}>
                    <section>
                      <span className={classes.bold}>Return reason: </span>
                      {reason}
                    </section>

                  </section>
                  {!!files.length && (
                    <section className={classes.photos}>
                      <span className={classes.bold}>Photos:&nbsp;</span>
                      <span style={{ wordBreak: 'break-word' }}>{files.join('; ')}</span>
                    </section>
                  )}
                  {!!comment && (
                    <section className={classes.additional}>
                      <span className={classes.bold}>Additional comments: </span>
                      {comment}
                    </section>
                  )}
                </section>

              )}
          </section>
        );
      })}
    </section>
  );
};

const ClaimItem = ({ claimItem, type, timeZone }) => {
  if (!claimItem) {
    return null;
  }
  const {
    claimId = '',
    claimStatus = '',
  } = claimItem;

  const textConfig = POLICY_ISSUE_TEXT[type] || {};

  const dateText = textConfig.date.text(claimStatus);
  const dateValue = claimItem[textConfig.date.id];
  const reasonValue = claimItem[textConfig.reason.id];
  const IssueBlock = ClaimIssueMap[type];

  return (
    <div className={classes.claimItem}>
      <div className={classes.header}>
        <section className={classes.info}>
          <Dot />
          <section className={classes.claimId}>{`ISSUE ID #${claimId}`}</section>
          <ClaimStatus status={claimStatus} />
        </section>
        {dateValue ? <section className={classes.time}>{`${dateText} ${formatTime(dateValue, '', timeZone)}`}</section> : null}
      </div>
      {reasonValue ? <div className={classes.returnReason}>{`${textConfig.reason.text}: ${reasonValue}`}</div> : null}
      <IssueBlock claimItem={claimItem} />
    </div>
  );
};

const NewClaim = React.memo(({ claimInfo = {}, timeZone }) => {
  const {
    claimId, status, history = [], attachments = [], transactions = [],
    estimatedRefund: { resolution } = {},
    issueTypeDesc, items, policyType,
  } = claimInfo;
  let dateValue = `Submitted on ${formatTime(history[0]?.eventTime, '', timeZone)}`;
  let text = 'Issue is under review';
  if (status === 'Accepted') {
    const info = history.find((item) => item.title === status) || {};
    text = 'Refunded';
    dateValue = `Accepted at ${formatTime(info.eventTime, '', timeZone)}`;
  } else if (status === 'Rejected') {
    const info = history.find((item) => item.title === status) || {};
    dateValue = `Rejected at ${formatTime(info.eventTime, '', timeZone)}`;
    // eslint-disable-next-line prefer-destructuring
    text = info.desc?.split('<br>')[1];
  }
  const refundInfo = transactions.find((item) => item.transactionType === 'claim_payment') || {};
  const shippingInfo = transactions.find((item) => item.transactionType === 'shipping_fee') || {};
  const resolutionText = paymentMethods[resolution]?.title;
  return (
    <div className={classes.claimItem}>
      <div className={classes.header}>
        <section className={classes.info}>
          <Dot />
          <section className={classes.claimId}>{`ISSUE ID #${claimId}`}</section>
          <ClaimStatus status={status} />
        </section>
        {dateValue ? <section className={classes.time}>{dateValue}</section> : null}
      </div>
      {issueTypeDesc ? <div className={classes.returnReason}>{`Issue type: ${issueTypeDesc}`}</div> : null}
      {resolution ? <div className={classes.returnReason}>{`Resolution: ${resolutionText || ''}`}</div> : null}
      {items?.map((packageItem, index) => (
        <PackageItem
          // eslint-disable-next-line react/no-array-index-key
          key={`${packageItem.fulfillmentId}_${index}`}
          packageItem={packageItem}
          index={index}
          orderName={packageItem.fulfillmentName}
        />
      ))}
      {!!attachments.length
        && (
          <section>
            <section className={classes.split_line} />
            <section className={classes.reported_title_padding}>
              <span className={classes.title_bold}>Supporting documents:</span>
              <span>{attachments.map((file) => file.originalFileName).join('; ')}</span>
            </section>
          </section>
        )}
      {policyType?.indexOf('bp') > -1
        && (
          <>
            <section className={classes.split_line} />
            <section className={classes.shipping_fee}>
              <section className={classes.title}>Return shipping fee </section>
              <section className={classes.value}>{shippingInfo.presentation || '$0.00 USD'}</section>
            </section>
          </>

        )}

      <section className={classes.split_line} />
      <section className={classes.refund}>
        <section className={classes.title}>{text}</section>
        {status === 'Accepted' && <section className={classes.value}>{refundInfo.presentation}</section>}
      </section>

    </div>
  );
});

export const PolicyDetailClaim = React.memo(({ policyDetail, type }) => {
  if (!policyDetail) {
    return null;
  }
  const { settingsInfo: { timeZone } = {} } = useSettings();

  const { raPolicyClaimsVO = {}, getClaimDetailResponse = [], policyType } = policyDetail;
  // 如果有新理赔数据走新版claim info
  const NewClaimLen = getClaimDetailResponse.length;
  if (NewClaimLen) {
    return (
      <PolicyPanel PolicyPanel title={`Issue (${NewClaimLen})`} icon={titleIcon}>
        {getClaimDetailResponse.map((item) => <NewClaim claimInfo={item} key={item.claimId} timeZone={timeZone} />)}
      </PolicyPanel>
    );
  }

  const { claimNum, policyClaimDetailVOS: claimList = [] } = raPolicyClaimsVO || {};
  if (!claimNum || !claimList?.length) {
    return null;
  }

  return (
    <PolicyPanel title={`Issue (${claimNum})`} icon={titleIcon}>
      {claimList.map((item) => (
        <ClaimItem
          claimItem={item}
          type={type}
          key={item.claimId}
          policyType={policyType}
          timeZone={timeZone}
        />
      ))}
    </PolicyPanel>
  );
});
